module.exports = __webpack_public_path__ + "assets/img/12_148_big.fa3289c5.jpg";